import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import SEOMetaTags from '../../components/SEO/SEOMetaTags';
import { useTranslation } from '../../hooks/useTranslation';

import technologiesEnterprise from '../../assets/images/tech/technology-enterprise.png';
import mateuszRecognition from '../../assets/images/team/Mateusz-recognition.png';

const EnterprisePage: React.FC = () => {
    const { t, tJsx } = useTranslation();

    const industryCards = [
        {
            text: t("enterprise.industry.card1"),
        },
        {
            text: t("enterprise.industry.card2"),
        },
        {
            text: t("enterprise.industry.card3"),
        }
    ];

    const howWeWorkSteps = [
        {
            title: t("enterprise.howWeWork.step1.title"),
            description: [
                t("enterprise.howWeWork.step1.description1"),
                t("enterprise.howWeWork.step1.description2"),
                t("enterprise.howWeWork.step1.description3")
            ],
        },
        {
            title: t("enterprise.howWeWork.step2.title"),
            description: [
                t("enterprise.howWeWork.step2.description1"),
                t("enterprise.howWeWork.step2.description2"),
                t("enterprise.howWeWork.step2.description3")
            ],
        },
        {
            title: t("enterprise.howWeWork.step3.title"),
            description: [
                t("enterprise.howWeWork.step3.description1"),
                t("enterprise.howWeWork.step3.description2")
            ],
        },
        {
            title: t("enterprise.howWeWork.step4.title"),
            description: [
                t("enterprise.howWeWork.step4.description1"),
                t("enterprise.howWeWork.step4.description2"),
                t("enterprise.howWeWork.step4.description3")
            ],
        }
    ];

    const nextSteps = [
        {
            title: t("enterprise.nextSteps.step1")
        },
        {
            title: t("enterprise.nextSteps.step2")
        },
        {
            title: t("enterprise.nextSteps.step3")
        }
    ];

    const technologies = [
        { name: "technologiesEnterprise", logo: technologiesEnterprise },
    ];

    const enterpriseCards = [
        {
            title: t("enterprise.cards.title1"),
            description: t("enterprise.cards.description1")
        },
        {
            title: t("enterprise.cards.title2"),
            description: t("enterprise.cards.description2")
        },
        {
            title: t("enterprise.cards.title3"),
            description: t("enterprise.cards.description3")
        },
        {
            title: t("enterprise.cards.title4"),
            description: t("enterprise.cards.description4")
        },
        {
            title: t("enterprise.cards.title5"),
            description: t("enterprise.cards.description5")
        },
        {
            title: t("enterprise.cards.title6"),
            description: t("enterprise.cards.description6")
        }
    ];

    return (
        <>
            <SEOMetaTags
                title={{
                    pl: "Appotype: Doradztwo Technologiczne, Audyty IT, Nadzór Projektów",
                    en: "Appotype: Technology Consulting, IT Audits, Project Supervision"
                }}
                description={{
                    pl: "Appotype: Eksperckie doradztwo technologiczne, audyty IT oraz nadzór autorski i inwestorski. Zapewniamy optymalizację, bezpieczeństwo i zgodność projektów IT z harmonogramem i budżetem.",
                    en: "Appotype: Expert technology consulting, IT audits, plus author's & investor's supervision. We ensure optimization, security, and alignment of IT projects with schedule & budget."
                }}
                canonicalUrl="/uslugi/enterprise"
            />
            <ServiceTemplate
                heroTitle={t("enterprise.hero.title")}
                heroSubtitle={t("enterprise.hero.subtitle")}
                industryTitle={t("enterprise.industry.title")}
                industryCards={industryCards}
                howWeWorkTitle={t("enterprise.howWeWork.title")}
                howWeWorkSteps={howWeWorkSteps}
                nextSteps={nextSteps}
                technologiesTitle={t("medtech.technologies.title")}
                technologies={technologies}
                enterpriseCards={enterpriseCards}
                recognition={{
                    title: t("enterprise.recognition.title"),
                    subtitle: [
                        t("enterprise.recognition.subtitle1"),
                        t("enterprise.recognition.subtitle2")
                    ],
                    recognitionImage: mateuszRecognition,
                }}
                caseStudyTitle={t("enterprise.caseStudy.title")}
            />
        </>
    );
};

export default EnterprisePage;